import React, { useState } from 'react';

const AuthScreen = ({ setUsername, setUserPfp, setCurrentScreen, setErrorMessage }) => {
  const [inputValue, setInputValue] = useState('');

  const handleLogin = () => {
    const trimmedUsername = inputValue.trim().replace(/^@/, '').toLowerCase();

    if (!trimmedUsername) {
      setErrorMessage('Please enter a valid Twitter username.');
      return;
    }

    const pfp = `https://unavatar.io/twitter/${trimmedUsername}`;
    setUsername(trimmedUsername);
    setUserPfp(pfp);
    setCurrentScreen('selectPuzzle');
  };

  return (
    <div className="flex flex-col items-center justify-center h-full px-4 text-center">
      <div className="bg-white p-8 rounded-xl shadow-2xl max-w-md w-full border-4 border-pink-500">
        <h2 className="text-3xl font-extrabold mb-6 text-pink-600">Enter Your Twitter Username</h2>
        <input
          type="text"
          placeholder="@yourhandle"
          value={inputValue}
          onChange={(e) => setInputValue(e.target.value)}
          className="w-full border-2 border-orange-400 rounded-lg p-3 mb-6 text-lg focus:outline-none focus:ring-2 focus:ring-pink-500"
        />
        <button
          onClick={handleLogin}
          className="w-full bg-gradient-to-r from-pink-500 to-orange-500 text-white font-bold py-3 px-6 rounded-lg shadow-lg hover:from-pink-600 hover:to-orange-600 transition duration-300 text-xl"
        >
          Continue
        </button>
      </div>
    </div>
  );
};

export default AuthScreen;
